/* Allows forEach in IE11 */
if(window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
if(window.HTMLCollection && !HTMLCollection.prototype.forEach) {
    HTMLCollection.prototype.forEach = Array.prototype.forEach;
}

/* Custom Select Menu */
var customSelects = document.querySelectorAll(".customSelect");

/* initialize each custom select */
customSelects.forEach(function (customSelect) {
    var buttons = customSelect.querySelectorAll(".buttonWrapper button");
    buttons.forEach(function (button) {
        button.addEventListener('click', function() {
            toggleCustomSelect(customSelect);
        });
    });
});

/*** Custom Select Menu ***/
/* Opens/Closes custom select menu */
function toggleCustomSelect(customSelect) {
    customSelect.classList.toggle("open");
}

/* Closes the custom select when click outside */
$(document).on("click", function(event){
    var $trigger = $(".customSelect");
    if($trigger !== event.target && !$trigger.has(event.target).length){
        $trigger.removeClass("open");
    }
});
/*** END Custom Select Menu ***/
